module.exports = SharedDependencies.ReactDOM['@local/application'];